import { isExactMatch } from "../../../../utils/line-item-matchers/shared.js";
const areSameNonPrescriptionBundleLineItem = (serverLineItem, draftLineItem) => {
  if (serverLineItem.__typename !== "LineItemBundle") {
    return false;
  }
  if (serverLineItem.typeDetails?.__typename !== "BundleNonPrescriptionBundleTypeDetails") {
    return false;
  }
  const serverSkus = new Set(serverLineItem.bundleLineItems.map((bl) => bl.legacyProduct.sku));
  const draftSkus = /* @__PURE__ */ new Set([draftLineItem.sku, ...draftLineItem.bundleLineItems.map((b) => b.sku)]);
  return isExactMatch(serverSkus, draftSkus);
};
export {
  areSameNonPrescriptionBundleLineItem
};
//# sourceMappingURL=are-same-non-prescription-bundle.js.map
